"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var topic_1 = require("./topic");
exports.InteractionContext = react_1.createContext({
    topic: "",
    name: "",
    isComplete: false,
    complete: function () { }
});
exports.Interaction = function (_a) {
    var children = _a.children, name = _a.name, _b = _a.autoComplete, autoComplete = _b === void 0 ? true : _b;
    var topic = react_1.useContext(topic_1.TopicContext);
    var _c = react_1.useState({ isComplete: autoComplete }), state = _c[0], setState = _c[1];
    return (react_1.default.createElement(exports.InteractionContext.Provider, { value: {
            topic: topic.name,
            name: name,
            isComplete: state.isComplete,
            complete: function () { return setState({ isComplete: true }); }
        } },
        react_1.default.createElement(creator_ui_1.Box, { as: "section", id: name, minHeight: "calc(100vh - 180px)", height: "calc(100vh - 180px)", width: "100%", p: "20px" }, children)));
};
exports.Interaction.displayName = "Interaction";
exports.Interaction.editableFields = [];
exports.Interaction.editableContainer = react_1.forwardRef(function (props, ref) {
    var p = __assign({}, props);
    delete p.onClick;
    delete p.onKeyPress;
    delete p.tabIndex;
    return react_1.default.createElement(creator_ui_1.Box, __assign({}, p, { ref: ref, p: "0px", m: "30px", width: "calc(100% - 60px)" }));
});
